<template>
  <div
    v-if="produtos.length > 0 || imagem !== ''"
  >
    <template v-if="produtos.length > 0 && imagem === ''">
      <div
        v-for="(produto, index) in produtos"
        :key="`produto-${index}`"
        :class="possuiCardSuperior ? 'pt-md-6' : ''"
        class="d-flex align-start mb-6"
      >
        <v-card>
          <v-img
            :src="produto.image_url"
            data-cy="detalhe_imagem_produto"
            height="120"
            width="115"
          />
        </v-card>
        <div>
          <p
            class="pl-5 mb-0 primary--text font-weight-bold"
          >
            {{ produto.name }} - {{ produto.plan_name }}
          </p>
          <v-btn
            class="ml-5 mt-5"
            data-cy="btn_avaliar_produto"
            outlined
            small
            :disabled="desabilitaBtn(produto)"
            @click="abrirModal(produto)"
          >
            {{ produtoAvaliado() ? 'Ver avaliação' : 'Avaliar produto' }}
          </v-btn>
        </div>
      </div>
    </template>
    <template v-else>
      <div
        :class="possuiCardSuperior ? 'pt-md-6' : ''"
        class="d-flex align-start mb-6"
      >
        <v-card>
          <v-img
            :src="imagem"
            data-cy="detalhe_imagem_produto"
            height="120"
            width="115"
          />
        </v-card>
        <div>
          <p
            class="pl-5 mb-0 primary--text font-weight-bold"
          >
            {{ titulo }}
          </p>
          <v-btn
            class="ml-5 mt-5"
            data-cy="btn_avaliar_produto"
            outlined
            small
            :disabled="desabilitaBtn(produtos[0])"
            @click="abrirModal(produtos[0])"
          >
            {{ produtoAvaliado() ? 'Ver avaliação' : 'Avaliar produto' }}
          </v-btn>
        </div>
      </div>
    </template>
    <ScoreProduto
      v-if="dialog"
      :dialog="dialog"
      :produto="produtoScore"
      @changeDialog="value => dialog = value"
    />
  </div>
</template>

<script>
import ScoreProduto from '@/components/Compras/ScoreProduto.vue';
import { mapState } from 'vuex';
import moment from 'moment';

export default {
  name: 'CardFotoProduto',

  components: {
    ScoreProduto,
  },

  props: {
    imagem: {
      type: String,
      default: '',
    },
    possuiCardSuperior: {
      type: Boolean,
      default: false,
    },
    produtos: {
      type: Array,
      default: () => [],
      required: true,
    },
    titulo: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      dialog: false,
      produtoAtual: {},
      produtoAtualScore: {},
      produtoScore: {},
    };
  },

  computed: {
    ...mapState(['dadosTransacao']),

    transacaoConfirmada() {
      return this.dadosTransacao.status_slug === 'finalizada';
    },
  },

  methods: {
    abrirModal(produto) {
      this.produtoScore = produto;
      this.dialog = true;
    },

    desabilitaBtn(produto) {
      Object.assign(this.produtoAtual, produto);

      if (this.produtoAvaliado()) return false;
      if (this.transacaoConfirmada && !this.produtoFisico()) return false;
      if (this.produtoEntregue()) return false;
      return true;
    },

    produtoAvaliado() {
      this.retornaProdutoScore();

      if (this.produtoAtualScore.value) {
        const { value } = this.produtoAtualScore;
        return !!value;
      }
      return false;
    },

    produtoEntregue() {
      const { product_delivered: entregue } = this.dadosTransacao;
      if (entregue) return true;

      return moment(this.dadosTransacao.paid_at).diff(moment(), 'days') < -15;
    },

    produtoFisico() {
      const produtoParaEntrega = this.dadosTransacao.shipping_address.products;

      return produtoParaEntrega.includes(this.produtoAtual.id);
    },

    retornaProdutoScore() {
      const { products: produtos } = this.dadosTransacao;

      if (produtos) {
        const produto = produtos.find(elemento => elemento.id === this.produtoAtual.id);
        Object.assign(this.produtoAtualScore, produto.score);
      }
    },
  },
};
</script>

